import Icon from '../components/Icon.vue'

Icon.register({
  'satellite-dish': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M188.8 345.9L216.2 318.5C218.8 319.2 221.2 320.1 224 320.1 241.7 320.1 256 305.8 256 288.1S241.7 256.1 224 256.1 192 270.4 192 288.1C192 290.9 192.9 293.3 193.6 295.9L166.2 323.3 49.4 206.5C42.1 199.2 29.3 200.4 24.4 209.5-17.4 287.3-5.5 386.2 60.1 451.8 125.7 517.4 224.7 529.3 302.4 487.5 311.6 482.6 312.8 469.8 305.4 462.5L188.8 345.9zM209 0C199.8-0.5 192 6.8 192 16V47.6C192 56.1 198.6 63.1 207 63.5 336.4 70.5 440.4 175.5 447.9 305 448.4 313.4 455.4 320 463.8 320H495.9C505.1 320 512.4 312.2 511.9 303 503.4 139.8 372.2 8.6 209 0zM209.3 96C200 95.3 192 102.7 192 112.1V144.2C192 152.6 198.5 159.5 206.8 160.1 283.6 166.4 344.8 228.3 351.7 305.3 352.5 313.6 359.3 320 367.6 320H399.8C409.1 320 416.6 312 415.9 302.7 407.5 192.6 319.4 104.5 209.3 96z'
      }
    ]
  }
})
